/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitCardCustomizationForReviewRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/customizations/v1/submit_customization_for_review.pb'
import {SubmitCardCustomizationForReviewResponse} from '@cash-web/protos/squareup/cash/whimsicard/api/customizations/v1/submit_customization_for_review.pb'


export const submitCardCustomizationForReview = (request: SubmitCardCustomizationForReviewRequest, options?: CashRequestOptions) => post<SubmitCardCustomizationForReviewRequest, SubmitCardCustomizationForReviewResponse>("/2.0/cash/submit-card-customization-for-review", request, {...options, rejectOnError: true })